import React from 'react';

export default function SvgImsKit({ isMobile }) {
  if (isMobile) {
    return (
      <>
        <svg
          width="63"
          height="40"
          viewBox="0 0 63 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
          }}
        >
          <path
            opacity="0.25"
            d="M61.718 -3.99992L37.491 5.33341L-3.66724 -10.8333"
            stroke="white"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.375"
            d="M50.1336 -4.22217L27.7444 6.83339L-10.2949 -1.11106"
            stroke="#F1ECFB"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5"
            d="M38.5491 -4.44434L17.9979 8.33344L-16.9782 8.66677"
            stroke="#E3DAF6"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.625"
            d="M26.9647 -4.61108L8.25138 9.83336L-23.6058 18.3889"
            stroke="#D4C7F2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.75"
            d="M15.3802 -4.83325L-1.49519 11.2779L-30.2335 28.1112"
            stroke="#C6B4EE"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.875"
            d="M3.7401 -5.05542L-11.2417 12.7779L-36.8611 37.889"
            stroke="#B8A2E9"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M-39.9243 49.2778L-13.7479 50.6667L-44.7697 16.4445L7.02612 6.50002L34.4835 -21.6111"
            stroke="#56008E"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.9167"
            d="M29.3596 -22.8888C29.5267 -22.7777 6.91471 4.11121 7.0261 5.72232C7.08179 6.22232 2.23638 7.44454 2.23638 7.44454L-41.9293 12.7779L-14.5833 47.2779L-35.5245 49.5001"
            stroke="#64189D"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.8333"
            d="M24.18 -24.1666C24.5142 -23.9444 6.69193 1.72226 6.91471 4.88893C6.9704 5.83337 3.12749 7.22226 3.12749 7.22226L-39.1446 9.11115L-15.4745 43.8889L-31.1803 49.7223"
            stroke="#7230AB"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.75"
            d="M19.0004 -25.4443C19.5017 -25.0554 6.52486 -0.611005 6.85903 4.16677C6.97041 5.55566 4.13 7.05566 4.13 7.05566L-36.2485 5.50011L-16.3099 40.5001L-26.8361 49.9445"
            stroke="#8048BA"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.6667"
            d="M13.8765 -26.6666C14.5449 -26.2222 6.41348 -2.99996 6.85903 3.38893C6.97042 5.27782 5.13251 6.88893 5.13251 6.88893L-33.4637 1.83337L-17.1453 37.1667L-22.4919 50.2223"
            stroke="#8E5FC8"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5833"
            d="M8.69692 -27.9443C9.53234 -27.3888 6.24637 -5.38878 6.74762 2.61122C6.9147 5.00011 6.02359 6.72233 6.02359 6.72233L-30.6234 -1.83322L-17.9807 33.7223L-18.0921 50.389"
            stroke="#9C77D7"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5"
            d="M3.51738 -29.2222C4.85404 -28.3333 7.02613 6.50005 7.02613 6.50005L-27.7829 -5.49995L-13.7479 50.6112"
            stroke="#AA8FE5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M31.0861 -23.1666L2.29209 25.8334L-34.3549 13.8334"
            stroke="#00FFFF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.9167"
            d="M-34.8561 14L0.565586 27.3333L27.0205 -24.5555"
            stroke="#1CECFB"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.8333"
            d="M-35.3574 14.2222L-1.16097 28.8333L22.9547 -26"
            stroke="#39DAF6"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.75"
            d="M-35.9143 14.4446L-2.83181 30.3334L18.889 -27.4443"
            stroke="#55C7F2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.6667"
            d="M-36.4155 14.6668L-4.55831 31.8334L14.8234 -28.8888"
            stroke="#71B4EE"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5833"
            d="M-36.9168 14.889L-6.28487 33.3334L10.7576 -30.3333"
            stroke="#8EA2E9"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5"
            d="M-37.418 15.1112L-8.01136 34.8334L6.69198 -31.7222"
            stroke="#AA8FE5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5"
            d="M-30.7347 78.0556L-17.8693 16.8889L44.954 -11.5"
            stroke="#FF00FF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.4583"
            d="M42.8376 -15.8889L-17.5909 18.8889L-33.6309 75.8889"
            stroke="#F016FF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.4167"
            d="M40.777 -20.3334L-17.3123 20.8888L-36.5269 73.7222"
            stroke="#E12CFF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.375"
            d="M38.6605 -24.7222L-17.0339 22.8889L-39.3674 71.5556"
            stroke="#D343FF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.3333"
            d="M36.5998 -29.1666L-16.6997 24.9445L-42.2635 69.3889"
            stroke="#C459FF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.2917"
            d="M34.4835 -33.5555L-16.4213 26.9445L-45.1596 67.2222"
            stroke="#B56FFF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.25"
            d="M32.4228 -38L-16.1428 28.9444L-48 65.0556"
            stroke="#A685FF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <svg
          width="56"
          height="27"
          viewBox="0 0 56 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
          }}
        >
          <path
            opacity="0.5"
            d="M21.3932 32.8333L25.2147 19.8655L34.2506 31.8714L41.6078 19.8655L52.5723 31.8714L59.3939 19.0817L70.7155 18.6542"
            stroke="#AA8FE5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5833"
            d="M70.037 16.4455L64.144 15.8755L59.0368 17.2293L56.1796 22.8938L54.7867 29.3777L54.5724 29.0214L49.4652 23.6776L42.6079 18.1912L35.5006 29.8052L35.215 29.5202L29.3577 23.3925L26.2862 20.4356L22.0361 32.6553"
            stroke="#8EA2E9"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.6667"
            d="M69.3583 14.2011L63.3582 12.8473L58.7153 15.3767L55.7867 21.4331L57.001 26.8839V26.6345L51.4294 21.1125L43.6079 16.5168L36.7863 27.7389L36.5006 27.5964L30.3576 22.68L27.3933 21.0056L22.6432 32.5128"
            stroke="#71B4EE"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.75"
            d="M68.6798 11.9922L62.5369 9.85461L58.3582 13.5241L55.3939 19.9724L59.2153 24.39L59.4296 24.2475L53.4295 18.5117L44.5722 14.8422L38.0364 25.6725H37.7864L31.322 21.9674L28.4648 21.5399L23.2861 32.3345"
            stroke="#55C7F2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.8333"
            d="M68.0012 9.78338L61.7511 6.86206L58.001 11.6359L55.0009 18.5117L61.4296 21.9318L61.8225 21.8606L55.4296 15.9467L45.5722 13.1678L39.3221 23.6418L39.0721 23.7487L32.2863 21.2905L29.5362 22.1099L23.929 32.1921"
            stroke="#39DAF6"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.9167"
            d="M67.3225 7.53897L60.9653 3.86951L57.6438 9.7834L54.608 17.0155L63.6439 19.438H64.2511L57.3938 13.346L46.5722 11.4934L40.5721 21.5756L40.3578 21.7893L33.2862 20.578L30.6433 22.68L24.5718 32.0139"
            stroke="#1CECFB"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M66.644 5.33019L60.1439 0.876953L54.2152 15.5548L66.644 17.0511L59.3939 10.7809L47.5366 9.81904L41.6078 19.8655H34.2506L25.2147 31.8715"
            stroke="#00FFFF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36.6436 31.8715L59.3939 10.781V31.8715"
            stroke="#FF00FF"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.9167"
            d="M30.7148 31.5866L55.6439 13.0612L60.7868 31.5866"
            stroke="#E300EC"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.8333"
            d="M24.7505 31.3371L51.8938 15.3411L62.1798 31.3371"
            stroke="#C700D9"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.75"
            d="M18.8218 31.0522L48.108 17.6212L63.5726 31.0522"
            stroke="#AA00C7"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.6667"
            d="M12.8931 30.8028L44.3579 19.9369L64.9654 30.8028"
            stroke="#8E00B4"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5833"
            d="M6.92871 30.5176L40.6079 22.2168L66.3584 30.5176"
            stroke="#7200A1"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            opacity="0.5"
            d="M1 30.2683L36.8221 24.4969L67.7155 30.2683"
            stroke="#56008E"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    );
  }
  return (
    <>
      <svg
        width="199"
        height="211"
        viewBox="0 0 199 211"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          top: -64,
          left: -30,
          bottom: 0,
        }}
      >
        <path
          opacity="0.25"
          d="M197.6 62.1L154.1 78.9L80.2001 49.8"
          stroke="white"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.375"
          d="M176.8 61.7L136.6 81.6L68.3 67.3"
          stroke="#F1ECFB"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M156 61.3L119.1 84.3L56.3 84.9"
          stroke="#E3DAF6"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.625"
          d="M135.2 61L101.6 87L44.4001 102.4"
          stroke="#D4C7F2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.75"
          d="M114.4 60.6L84.1001 89.6L32.5001 119.9"
          stroke="#C6B4EE"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.875"
          d="M93.5001 60.2L66.6001 92.3L20.6001 137.5"
          stroke="#B8A2E9"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M72.7001 59.9L8.70007 155"
          stroke="#AA8FE5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.1001 158L62.1001 160.5L6.40009 98.9L99.4001 81L148.7 30.4"
          stroke="#56008E"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.9167"
          d="M139.5 28.1C139.8 28.3 99.2001 76.7 99.4001 79.6C99.5001 80.5 90.8001 82.7 90.8001 82.7L11.5001 92.3L60.6001 154.4L23.0001 158.4"
          stroke="#64189D"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.8333"
          d="M130.2 25.8C130.8 26.2 98.8001 72.4 99.2001 78.1C99.3001 79.8 92.4001 82.3 92.4001 82.3L16.5001 85.7L59.0001 148.3L30.8001 158.8"
          stroke="#7230AB"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.75"
          d="M120.9 23.5C121.8 24.2 98.5001 68.2 99.1001 76.8C99.3001 79.3 94.2001 82 94.2001 82L21.7001 79.2L57.5001 142.2L38.6001 159.2"
          stroke="#8048BA"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.6667"
          d="M111.7 21.3C112.9 22.1 98.3001 63.9 99.1001 75.4C99.3001 78.8 96.0001 81.7 96.0001 81.7L26.7001 72.6L56.0001 136.2L46.4001 159.7"
          stroke="#8E5FC8"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5833"
          d="M102.4 19C103.9 20 98.0001 59.6 98.9001 74C99.2001 78.3 97.6001 81.4 97.6001 81.4L31.8001 66L54.5001 130L54.3001 160"
          stroke="#9C77D7"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M93.1001 16.7C95.5001 18.3 99.4001 81 99.4001 81L36.9001 59.4L62.1001 160.4"
          stroke="#AA8FE5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M142.6 27.6L90.9001 115.8L25.1001 94.2"
          stroke="#00FFFF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.9167"
          d="M24.2001 94.5L87.8001 118.5L135.3 25.1"
          stroke="#1CECFB"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.8333"
          d="M23.3001 94.9L84.7001 121.2L128 22.5"
          stroke="#39DAF6"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.75"
          d="M22.3001 95.3L81.7001 123.9L120.7 19.9"
          stroke="#55C7F2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.6667"
          d="M21.4001 95.7L78.6001 126.6L113.4 17.3"
          stroke="#71B4EE"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5833"
          d="M20.5001 96.1L75.5001 129.3L106.1 14.7"
          stroke="#8EA2E9"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M19.6001 96.5L72.4001 132L98.8001 12.2"
          stroke="#AA8FE5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M31.6001 209.8L54.7001 99.7L167.5 48.6"
          stroke="#FF00FF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4583"
          d="M163.7 40.7L55.2001 103.3L26.4001 205.9"
          stroke="#F016FF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.4167"
          d="M160 32.7L55.7001 106.9L21.2001 202"
          stroke="#E12CFF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.375"
          d="M156.2 24.8L56.2001 110.5L16.1001 198.1"
          stroke="#D343FF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.3333"
          d="M152.5 16.8L56.8001 114.2L10.9001 194.2"
          stroke="#C459FF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.2917"
          d="M148.7 8.90002L57.3001 117.8L5.70007 190.3"
          stroke="#B56FFF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.25"
          d="M145 0.900024L57.8001 121.4L0.600098 186.4"
          stroke="#A685FF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <svg
        width="197"
        height="91"
        viewBox="0 0 197 91"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: 'absolute',
          top: 12,
          right: -12,
          bottom: 0,
        }}
      >
        <path
          opacity="0.5"
          d="M57.6 90.2L68.3 53.8L93.6 87.5L114.2 53.8L144.9 87.5L164 51.6L195.7 50.4"
          stroke="#AA8FE5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5833"
          d="M193.8 44.2L177.3 42.6L163 46.4L155 62.3L151.1 80.5L150.5 79.5L136.2 64.5L117 49.1L97.1 81.7L96.3 80.9L79.9 63.7L71.3 55.4L59.4 89.7"
          stroke="#8EA2E9"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.6667"
          d="M191.9 37.9L175.1 34.1L162.1 41.2L153.9 58.2L157.3 73.5V72.8L141.7 57.3L119.8 44.4L100.7 75.9L99.9 75.5L82.7 61.7L74.4 57L61.1 89.3"
          stroke="#71B4EE"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.75"
          d="M190 31.7L172.8 25.7L161.1 36L152.8 54.0999L163.5 66.5L164.1 66.0999L147.3 50L122.5 39.7L104.2 70.0999H103.5L85.4 59.6999L77.4 58.5L62.9 88.8"
          stroke="#55C7F2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.8333"
          d="M188.1 25.5L170.6 17.3L160.1 30.7001L151.7 50L169.7 59.6L170.8 59.4001L152.9 42.8L125.3 35L107.8 64.4001L107.1 64.7L88.1 57.8001L80.4 60.1L64.7 88.4001"
          stroke="#39DAF6"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.9167"
          d="M186.2 19.2L168.4 8.90002L159.1 25.5L150.6 45.8L175.9 52.6H177.6L158.4 35.5L128.1 30.3L111.3 58.6L110.7 59.2L90.9 55.8L83.5 61.7L66.5 87.9"
          stroke="#1CECFB"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M184.3 13L166.1 0.5L149.5 41.7L184.3 45.9L164 28.3L130.8 25.6L114.2 53.8H93.6L68.3 87.5"
          stroke="#00FFFF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M100.3 87.5L164 28.3V87.5"
          stroke="#FF00FF"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.9167"
          d="M83.7 86.7001L153.5 34.7001L167.9 86.7001"
          stroke="#E300EC"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.8333"
          d="M67 86.0001L143 41.1001L171.8 86.0001"
          stroke="#C700D9"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.75"
          d="M50.4 85.2L132.4 47.5L175.7 85.2"
          stroke="#AA00C7"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.6667"
          d="M33.8 84.5L121.9 54L179.6 84.5"
          stroke="#8E00B4"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5833"
          d="M17.1 83.7L111.4 60.4L183.5 83.7"
          stroke="#7200A1"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          opacity="0.5"
          d="M0.5 83L100.8 66.8L187.3 83"
          stroke="#56008E"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
}
